/**
 * Drive IQ — the name on every piece of thinking Driveline does for a workshop.
 *
 * The assistant, the SOP drafts, the invoice reading, the training plans and
 * the translations are all the same intelligence, so they all carry the same
 * mark. A workshop owner who sees it on their expense screen should recognise
 * it instantly in the help panel.
 */
import React from 'react';

export const DRIVE_IQ = {
  name: 'Drive IQ',
  tagline: 'Know Your Business Inside Out',
};

/** The wordmark itself: "Drive" plain, "IQ" in the accent. */
export const DriveIQWordmark = ({ className = '' }) => (
  <span className={`font-semibold tracking-tight ${className}`}>
    Drive<span className="!text-[#0d9488] dark:!text-[#2dd4bf]">IQ</span>
  </span>
);

/**
 * A small badge for the corner of any AI surface.
 *  - `label` prefixes the name, e.g. "Read by" → "Read by DriveIQ"
 *  - `busy` pulses while the model is actually working
 */
export const DriveIQBadge = ({ label = '', busy = false, className = '', testId }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border border-teal-500/25 bg-teal-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider !text-[#0f766e] dark:!text-[#5eead4] ${className}`}
    title={`${DRIVE_IQ.name} — ${DRIVE_IQ.tagline}`}
    data-testid={testId || 'driveiq-badge'}
  >
    <span
      className={`h-1.5 w-1.5 rounded-full bg-teal-500 ${busy ? 'animate-pulse' : ''}`}
      aria-hidden="true"
    />
    {label ? `${label} ` : ''}
    <DriveIQWordmark className="normal-case tracking-tight" />
  </span>
);

export default DriveIQBadge;
